import { collection, doc, getDocs, setDoc, serverTimestamp, writeBatch } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { defaultAutomations } from '@/types/automation';

export async function initializeAutomations(): Promise<void> {
  try {
    const automationsRef = collection(db, collections.automations);
    const snapshot = await getDocs(automationsRef);

    // Only initialize if collection is empty
    if (snapshot.empty) {
      const batch = writeBatch(db);
      
      for (const automation of defaultAutomations) {
        const docRef = doc(automationsRef, automation.id);
        batch.set(docRef, {
          ...automation,
          created_at: serverTimestamp(),
          updated_at: serverTimestamp()
        });
      }

      await batch.commit();
      console.log('Successfully initialized automations collection');
    } else {
      // Check for missing automations and add them
      const existingIds = new Set(snapshot.docs.map(doc => doc.id));
      const missingAutomations = defaultAutomations.filter(automation => !existingIds.has(automation.id));

      if (missingAutomations.length > 0) {
        const batch = writeBatch(db);
        
        for (const automation of missingAutomations) {
          const docRef = doc(automationsRef, automation.id);
          batch.set(docRef, {
            ...automation,
            created_at: serverTimestamp(),
            updated_at: serverTimestamp()
          });
        }

        await batch.commit();
        console.log(`Added ${missingAutomations.length} missing automations`);
      }
    }
  } catch (error) {
    console.error('Error initializing automations:', error);
    throw new Error('Failed to initialize automations');
  }
}